<template>
  <LexemeList />
</template>
<script>
// @ is an alias to /src
import LexemeList from "@/components/LexemeList.vue";

export default {
  name: "Dictionary",
  components: {
    LexemeList,
  },
};
</script>
